import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { State } from './State';
import {initialState} from './reducer'
import reducer from './reducer'
ReactDOM.render(
  <React.StrictMode>
    <State initialState={initialState} reducer={reducer}>
    <App />
    </State>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
